<!-- Our Team Block -->
<section id="our-team">
  <div class="container text-center">
    <h2>Our Team</h2>
    <p>Wholesale Flights is a travel agency specializing in providing discounted prices on business and first class
      airfares. Our team of reliable and trustworthy agents have years of experience and expertise. We focus on
      developing personalized, long-term relationships with our clients to provide exceptional customer service
      and deeply discounted airfares. Started in 2007, Wholesaleflights.com  is located in Bay Area Redwood City,
      California. Please feel free to read more about each of our agents and contact us
      to discuss booking your next trip.</p>
  </div>

  <div class="container">
    <div class="row justify-content-center" *ngFor="let key of objectKeys(users)">
      <ng-container *ngFor="let user of users[key]">
        <div *ngIf="user.position" class="col-6 col-md-2 col-lg-2">
          <div class="card">
            <img class="card-img-top" src="{{cdnPath + user.image}}" alt="{{user.fullName}}">
            <div class="card-block">
              <h4 class="card-title">
                <a *ngIf="user.position !== 'CEO' && user.position !== 'President'" [routerLink]="['/our-team', user.userLink]">{{user.fullName}}</a>
                <span class="leader"*ngIf="user.position === 'CEO' || user.position === 'President'">{{user.fullName}}</span>
                <span>{{user.position}}</span>
              </h4>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
